import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BatteryStdIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_std"}/>
}
